import { XHRBackend, Http, RequestOptions } from "@angular/http";
import { InterceptedHttp } from "./http.interceptor";
import { LocalStorageService } from 'angular-2-local-storage';
import { LoaderService, HttpIntegrationService } from './index';

export function httpFactory(xhrBackend: XHRBackend, requestOptions: RequestOptions, localStorageService: LocalStorageService, loaderService: LoaderService, httpIntegrationService: HttpIntegrationService): Http {
    return new InterceptedHttp(xhrBackend, requestOptions, localStorageService, loaderService, httpIntegrationService);
}